import React from 'react';

const h = React.createElement;

/**
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {React.CSSProperties} [p.style]
 */
export function CardActions({ children, style }) { return h('div', { style: { display: 'flex', alignItems: 'center', gap: 6, flex: 'none', marginLeft: 'auto', ...style } }, children); }
